<!--Button component-->
<!--Has different classes for different button styles-->
<button type="button"
        [class]="'button ' + buttonType + (fillParent ? ' fill-parent' : '')"
        [disabled]="disabled"
        (click)="onClickFn($event)">
  <!--Left icon-->
  <svg-icon [src]="leftIconSource" class="icon left"></svg-icon>
  <!--Label-->
  <span class="font-button button-text">{{label}}</span>
  <!--Right icon-->
  <svg-icon [src]="rightIconSource" class="icon right"></svg-icon>
</button>
